module.exports = __webpack_public_path__ + "img/image 9.c3f66a06.png";